import { useQuery } from '@apollo/client/react';
import { GET_USER_PAYMENT_PROVIDERS } from '../services/membershipApi/apollo/queries';

interface PaymentProvider {
    provider: string;
    [key: string]: unknown;
}

interface GetUserPaymentProvidersData {
    getUserPaymentProviders: PaymentProvider[];
}

/**
 * Hook to fetch and check user payment providers
 * Returns payment providers list and subscription status
 */
export const usePaymentProviders = (userId?: string) => {
    const { data, loading, error } = useQuery<GetUserPaymentProvidersData>(GET_USER_PAYMENT_PROVIDERS, {
        variables: { userId: userId ?? '' },
        skip: !userId,
        fetchPolicy: 'cache-and-network',
    });

    const paymentProviders: PaymentProvider[] = data?.getUserPaymentProviders || [];
    const hasStripeSubscription = paymentProviders.some(
        (provider) => provider.provider === 'stripeSubscription'
    );

    return {
        paymentProviders,
        hasStripeSubscription,
        loading,
        error,
    };
};
